<template>
  <v-app id="403" style="scroll-behavior: auto; overflow: hidden;">
    <v-main class="background-home">
      <view-container>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="12">
              <div class="itemsCenter">
                <v-img
                  :src="logo"
                  class="my-3 d-flex align-content-center flex-wrap"
                  contain
                  :max-height="$vuetify.breakpoint.mobile ? 80 : 100"
                  :max-width="$vuetify.breakpoint.mobile ? 300 : 1000"
                />
              </div>
              <br />
            </v-col>
          </v-row>
        </v-container>
        <auto-container color="#F7F9F9">
          <v-container fluid fill-height>
            <v-layout align-center justify-center row>
              <div class="text-md-center">
                <h1 style="color: #005591" v-text="'403'" class="text-center" />
                <h2
                  class="my-3 headline "
                  style="color: #005591"
                  v-text="'Sorry, access denied'"
                />
              </div>
            </v-layout>
          </v-container>
        </auto-container>
      </view-container>
    </v-main>
  </v-app>
</template>

<script>
import { AutoContainer, ViewContainer } from "@/components";
import { logo } from "@/assets";

export default {
  name: "AccessDenied",
  components: {
    AutoContainer,
    ViewContainer,
  },
  data: () => ({
    logo: logo,
  }),
};
</script>

<style scoped>
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
